import { Component, OnInit, Inject } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui'
import { Router, NavigationStart, NavigationEnd, GuardsCheckStart, GuardsCheckEnd, NavigationError, NavigationCancel } from '@angular/router'
import { LoginService, ToastrService } from '../shared/index';

import { Adal5Service } from 'adal-angular5';
import { APP_CONFIG, IAppConfig } from "../app.config";
import { BlockUiTemplateComponent } from "../shared/utilities/block-ui-template/block-ui-template.component";

@Component({
    selector: 'app',
    template: require('./app.component.html'),
    styles: [require('./app.component.scss')]
})
export class AppComponent implements OnInit  {
    @BlockUI() blockUI: NgBlockUI;
    blockTemplate: BlockUiTemplateComponent = BlockUiTemplateComponent;

    constructor(private router: Router, private service: Adal5Service, @Inject(APP_CONFIG) private config: IAppConfig, private toastr: ToastrService,  private loginService: LoginService) {
        router.events.subscribe((val) => {
            if (val instanceof NavigationStart) {
                this.blockUI.start('Please Wait...');
            }

            if (val instanceof GuardsCheckStart) {
                this.blockUI.stop();
            }

            if (val instanceof GuardsCheckEnd) {
                this.blockUI.start('Please Wait...');
            }

            if (val instanceof NavigationError) {
                this.blockUI.stop();
            }

            if (val instanceof NavigationCancel) {
                this.blockUI.stop();
            }

            if (val instanceof NavigationEnd) {
                this.blockUI.stop();
            }
        });
    }

    async ngOnInit() {   
        
    }  
}